import React from 'react'
import styled from '@emotion/styled'
import ReactDOM from 'react-dom'
import {
  colors,
  layering,
  measurements,
  shadow,
  spacing,
} from '@mobi/component-library/Foundations'
import { shouldApplySafeAreaBottomPadding } from '@core/Settings/cssConditions'

export const BettingDrawerBase: React.FC<{
  isOpen: boolean
  testId?: string
  primaryButtonSlot?: React.ReactNode
  secondaryButtonSlot?: React.ReactNode
  noticeBoxSlot?: React.ReactNode
  shouldDisplayAboveTabNav?: boolean
  forcedZIndex?: number
}> = ({
  isOpen,
  testId,
  primaryButtonSlot,
  secondaryButtonSlot,
  noticeBoxSlot,
  shouldDisplayAboveTabNav = false,
  forcedZIndex,
}) => {
  return ReactDOM.createPortal(
    <WrapperStyled
      style={{ zIndex: forcedZIndex }}
      data-testid={testId}
      data-open={isOpen}
      data-above-tabs={shouldDisplayAboveTabNav}
    >
      <div>
        <div>
          <div>{noticeBoxSlot}</div>

          <div>
            {secondaryButtonSlot}

            {primaryButtonSlot}
          </div>
        </div>
      </div>
    </WrapperStyled>,
    document.body
  )
}

// ======
// Styles
// ======

const WrapperStyled = styled.div({
  boxSizing: 'border-box',
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  paddingBottom: shouldApplySafeAreaBottomPadding ? 'var(--safe-area-inset-bottom, 0)' : 0,
  maxWidth: measurements.mobi.maxWidth,
  margin: '0 auto',
  transition: 'transform 0.2s',
  transform: 'translateY(100%)',
  zIndex: layering.stickyPageElements,
  pointerEvents: 'none',
  boxShadow: shadow.md,

  '> div': {
    boxSizing: 'border-box',
    minHeight: measurements.mobi.bottomTabsHeight,
    padding: `${spacing.sm} ${spacing.md}`,
    backgroundColor: colors.white,
    pointerEvents: 'all',

    '> div': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      maxWidth: '40rem',
      margin: '0 auto',

      '> div:nth-of-type(1)': {
        ':empty': { display: 'none' },
      },

      '> div:nth-of-type(2)': {
        display: 'grid',
        gridAutoFlow: 'column',
        gridAutoColumns: '1fr',
        gap: spacing.smx1,
      },
    },
  },

  '&[data-open="true"]': {
    transform: 'translateY(0)',
  },

  '&[data-above-tabs="true"]': {
    paddingBottom: `calc(var(--safe-area-inset-bottom, 0) + ${measurements.mobi.bottomTabsHeight} + 1px)`,
  },
})
